import CreateActivityPage from '@/pages/activity/CreateActivityPage';

/**
 * ChildCreateWizard — barnvyns skapa-flöde (/create-activity/:formId).
 *
 * Designbeslut: skapandet återanvänder den befintliga CreateActivityPage, som
 * redan (a) skapar RIKTIGA aktiviteter via det testade form-pipelinet
 * (ActivityFormScene + ActivityApi), (b) i barnläge använder ChildActivityFormsDefs
 * (steg-progress + barnvänliga "nästa"-etiketter) och (c) sätter kompanjonens
 * mood/bubbla per steg (Title/Date/Duration → child.companion.createStep1..3).
 *
 * Att bygga en helt parallell wizard hade duplicerat — och riskerat att divergera
 * från — det fungerande skapandet utan att tillföra riktig funktion. Wizardens
 * visuella steg (emoji→tid→dag→bekräftelse) realiseras alltså genom det befintliga
 * formstegs-UI:t i barnläge. ChildRouteSwitch pekar hit i barnläge och på
 * CreateActivityPage i vuxenläge; båda renderar samma sida, vilket är korrekt —
 * sidan gatar internt på effectiveChildMode.
 */
const ChildCreateWizard = () => <CreateActivityPage />;

export default ChildCreateWizard;
